import { API_WALLET_URL, URL_CARDS, URL_ME } from 'config'
import { apiCall } from './base'

export const getCard = async ({ type }) => {
  const result = await apiCall(`${URL_CARDS}/api/v1/cards/${type}`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })
  return {
    ...result,
    data: result.data.result
  }
}

export const getBlockStatusReasons = async (data) => {
  const result = await apiCall(`${URL_CARDS}/api/v1/cards/status-reasons/`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true,
    data
  })
  return result.data
}

export const setToggleCard = async (data, card_uuid) => {
  const result = await apiCall(
    `${URL_CARDS}/api/v1/cards/toggle/${card_uuid}`,
    {
      baseURL: API_WALLET_URL,
      method: 'PATCH',
      withCredentials: false,
      immediately: true,
      data
    }
  )
  return result
}

export const requestNewCard = async (data) => {
  const result = apiCall(`${URL_CARDS}/api/v1/cards`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })
  return result
}

export const setBlockCard = async (data, card_uuid) => {
  const result = await apiCall(`${URL_CARDS}/api/v1/cards/block/${card_uuid}`, {
    baseURL: API_WALLET_URL,
    method: 'DELETE',
    withCredentials: false,
    immediately: true,
    data
  })

  return result.data
}

export const getUrlSensitiveData = ({
  uuid,
  styleType = 'my-cards',
  code = '123456'
}) =>
  apiCall(
    `${URL_CARDS}/api/v1/cards/${uuid}/sensitive-information/${styleType}/${code}`,
    {
      baseURL: API_WALLET_URL,
      method: 'GET',
      withCredentials: false,
      immediately: true,
      data: { code }
    }
  ).then((data) => data.data.result)

export const getUrlActivationPhysicalCard = async (uuid) =>
  apiCall(
    `${URL_CARDS}/api/v1/cards/${uuid}/activate-link?back_url=${window.location.origin}/mis-tarjetas`,
    {
      baseURL: API_WALLET_URL,
      method: 'GET',
      withCredentials: false,
      immediately: true
    }
  ).then((data) => data.data.result)

export const setActivationCodePhysicalCard = (data) =>
  apiCall(`${URL_CARDS}/api/v1/cards/${data.card_uuid}/associate`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data
  })

/* 
  used to get the current minimum balance required
  to request a physical card.
  */
export const getLimit = () =>
  apiCall(`${URL_ME}/api/v1/me/card/limit`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })
